import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {MenuItem, Table , TextField} from "@material-ui/core";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TablePagination from "@material-ui/core/TablePagination"; 
import Paper from "@material-ui/core/Paper";
import PropTypes from "prop-types";
import Skeleton from '@mui/material/Skeleton';
import { useDispatch, useSelector } from "react-redux";
import {getTasksForUser } from "../../store/action/taskAction.js";
import {getCoverageByCode} from "../../store/action/policy.js";
 
import { BsThreeDots } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import './ListClaimToBeLoadedToPlatform.css'
import { useNavigate } from "react-router-dom"; 
import {fetchUser} from "../../store/action/user.js";
 
import exportToExcel from '../../utils/convertJsonToExcel.js';
import PreviewButtonPopup from "../../components/TaskListSection/PreviewButtonPopup.js";
 
function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

 
function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}




function getSorting(order, orderBy) {
    return order === "desc"
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
    const classes = useStyles(); 
  const { order, orderBy, onRequestSort } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

    const headRows = [
        {
            id: "businessKey",
            align: "left",
            label: "N° Sinistre",
            width: "20%",
        },
        {
            id: "managementType",
            align: "left",
            label: "Type Dossier",
            width: "15%",
        },
        {
            id: "subscribedWaranties",
            align: "left",
            label: "Garanties touchés",
            width: "20%",
        },
        {
            id: "invoiceReceptionDate",
            align: "left",
            label: "Date insertion facture",
            width: "20%",
        },
        {
            id: "finaleReportReceptionDate",
            align: "left",
            label: "Date insertion rapport",
            width: "20%",
        },
         
    ];

    return (
        <tr className={classes.tableHeadRows} >
            
            {headRows.map((row) => (
                <TableCell
                    key={row.id}
                    align={row.align}
                    sortDirection={orderBy === row.id ? order : false}
                    style={{width: row.width, border:0 }}
                    className = {classes.tableSortLabel}
                >
                    <TableSortLabel
                  active={true}
                  direction={orderBy === row.id ? order : "desc"}
                  onClick={createSortHandler(row.id)}
                  style={{
                    whiteSpace: "nowrap",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    fontSize: 12,
                    lineHeight: "18px",
                    color: "rgba(181, 181, 195, 1)",
                  }}
              >
                {row.label}
              </TableSortLabel>
                </TableCell>
            ))}
            <TableCell align="left"  style={{border : 0  }} >
                {" "}
            </TableCell>
        </tr>    );
}


const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        minHeight: "85vh" 
    },
    tableCellSmall: {
        fontFamily : 'Poppins',
        fontWeight : 600,
        fontSize :14,
        lineHeight:'21px',
        color :'rgba(70, 78, 95, 1)',
        borderBottom: '1px solid  rgba(0, 0, 0, 0.08)'
    },
    selectInputDialog: {
        width: "100%",
        border: "0",
        padding: "5px",
        background: "rgba(243, 246, 249, 1)",
        height: "29.69px",
        borderRadius: 5,
        alignItems: 'center', // Vertically center the text
        justifyContent: 'center', // Horizontally center the text
    
      },
      inputContainer2: {
        border: "0.61px solid rgba(226, 217, 239, 1)",
        background: "rgba(255, 255, 255, 1)",
        width: "250px",
        height: "30px",
        borderRadius: 5,
        marginLeft: "20px",
      },
    paper: {
        width: "100%",
        borderRadius : '11px',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)'
    },
    tableWrapper: {
        padding :'40px'
    },
    tableHeadRows: {
        background: 'rgba(250, 250, 250, 1)',
        width: '191px',
        height: '53px',
        padding: '18px 16px',
        gap: '8px',
        color: 'rgba(32, 29, 35, 1)'
    },
    tableSortLabel:{
        color: 'rgba(181, 181, 195, 1)',
        fontFamily : 'Poppins',
        fontWeight : 600 ,
        fontSize :12,
        lineHeight:'18px'
    },
    titre :{
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 600,
        color: 'rgba(63, 66, 84, 1)',
    },
    titreLabel :{
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 400,
        color: 'rgba(32, 18, 70, 1)',
    },
    tablePagination:{
        fontFamily: 'Poppins',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '18px',
        color :'rgba(32, 18, 70, 1)'
    },
    dateRangeContainer: {
        display: 'flex',
        alignItems: 'center',
        height:'30px',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: 5,
        padding: '5px 10px',
    },
    dateContainer: {
        border: 'none',
        outline: 'none',
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: 5,
        fontFamily: 'Poppins',
        paddingLeft: '5px',
    },
    inputContainer: {
        border: '0.61px solid rgba(226, 217, 239, 1)',
        background: 'rgba(255, 255, 255, 1)',
        width: '251px',
        height: '29.69px',
        borderRadius: 5,
        marginLeft: '20px',
    },
    viewBtn: {
        width: '40px',
        height: '34px',
        borderRadius: '6px',
        backgroundColor:'rgba(240, 243, 199, 1)',
        border: 0,
        lineHeight: '18px',
        color: 'rgba(187, 200, 8, 1)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    taskNameColumn: {
        width: '100%',
        height: '100%',
        gap: '0px',
        fontFamily: 'Poppins',
        fontSize: '10.17px',
        fontWeight: 500,
        textAlign: 'left',
        color: 'rgba(187, 200, 8, 1)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    tableContent:{
        fontFamily: 'Inter',
        fontSize: 14,
        fontWeight: 400,
        //lineHeight: 19.6,
        textAlign: 'left',
        color: 'rgba(32, 29, 35, 0.8)',
        paragraph: {
            lineHeight: '32.69px',
        },
},
    sinistres: {
        fontFamily: 'Poppins',
        fontSize: 14,
        fontWeight: 600,
        textAlign: 'left',
        color: 'rgba(70, 78, 95, 1)',
    },
    dropdownMenu: {
        position: 'absolute',
        zIndex: 1,
        backgroundColor: 'white',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        //boxShadow: theme.shadows[5],
        marginRight: "140px",
        borderRadius:6,
    },
    dropdownItem: {
        padding: theme.spacing(1),
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
        color: 'rgba(32, 18, 70, 1)',
        fontFamily: 'Poppins',
        fontSize: '10px',
        fontWeight: 400,
        textAlign: 'left',
        width:'120px'
    },
    naText: {
        color: 'rgb(145, 145, 145)',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

    },
    paperModal:{
        backgroundColor: 'rgba(255, 255, 255, 1)',
        border: 'none',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
        padding: theme.spacing(2, 4, 3),
        width: '459px',
        height: '175px',
    },
    modalTitle:{
        fontFamily: 'Poppins',
        fontSize: '18px',
        fontWeight: 500,
        lineHeight: '21px',
        textAlign: 'left',
        marginBottom: '16px',
    },
    line: {
        height: '2px',
        backgroundColor: 'rgba(243, 246, 249, 1)',
        width: '100%',
        marginBottom: '16px',
    },
    selectModal: {
        width: '400px',
        height: '36px',
        borderRadius: '4px',
        border: '1px solid rgba(222, 222, 222, 1)',
    },
    optionItem: {
        width: "100%",
        padding: theme.spacing(1),
        cursor: "pointer",
        backgroundColor: "white",
        color: "rgba(32, 18, 70, 1)",
        fontFamily: "Poppins",
        fontSize: "10px",
        fontWeight: 400,
        textAlign: "left",
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
    specialInput: {
          color: "rgba(24, 28, 50, 0.58)",
          fontFamily: "Poppins",
          fontSize: "13px",
          fontWeight: 500,
          textAlign: "right",
          backgroundColor: "rgba(243, 246, 249, 1)",
          border: "none",
          width: "209px",
          height: "28px",
        },
      },
    todoListActions: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: 100,
        textAlign:'center'
    },
    todoSection: {
        flex: 1,
        height: 87,
        padding: 10,
        backgroundColor: 'rgba(255, 255, 255, 1)',
        border: '1px solid rgba(255, 255, 255, 1)',
        opacity: 1,
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '18px',
        color: 'rgba(181, 181, 195, 1)',
        position: 'relative',
        paddingTop: 20,
        paddingBottom:10,
        paddingLeft: 17
    },
    firstSection: {
        borderTopLeftRadius: 9,
        borderBottomLeftRadius: 9,
        paddingTop: 20
    },
    lastSection: {
        borderTopRightRadius: 9,
        borderBottomRightRadius: 9,
        paddingTop: 20
    },
    sectionLine: {
        content: '""',
        position: 'absolute',
        top: 7,
        bottom: 5,
        right: 0,
        width: 1,
        backgroundColor: 'rgba(244, 241, 249, 1)',
    },
    sectionText: {
        fontFamily: 'Poppins',
        fontSize: 20,
        fontWeight: 600,
        color: 'rgba(70, 78, 95, 1)',
        display: 'block',
        paddingLeft: 0,
        marginTop: 5,
    },
    autocompleteTag: {
        fontFamily: "Poppins, sans-serif",
        backgroundColor: "rgba(240, 243, 199, 1)",
        color: "rgba(187, 200, 8, 1)",
        border: "none",
        fontSize: "0.75rem",
        padding: "2px 6px",
        alignItems: "center",
        justifyContent: "center",
        margin: "2px",
        borderRadius: "16px",
        display: "inline-block",
        maxWidth: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
}));

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number,
};
function CoverageCell({ coverageCode }) {
    const [coverageLabel, setCoverageLabel] = useState(coverageCode);
    const classes = useStyles();
    useEffect(() => {
        async function fetchDataCoverage() {
            if (coverageCode) {
                try {
                    const code = coverageCode.slice(1, -1);
                    const coverage = await getCoverageByCode(code);
                    setCoverageLabel(coverage?.label || coverageCode);
                } catch (error) {
                    console.error('Error fetching coverage by code:', error);
                    setCoverageLabel(coverageCode);
                }
            }
        }

        fetchDataCoverage();
    }, [coverageCode]);

    return (
        <TableCell
            align="left"
            className={classes.tableCellSmall}
            style={{ borderBottom: 'none' }}
        >
            <span
                style={{
                    width: '69px',
                    height: '26px',
                    borderRadius: '51px',
                    background: 'rgba(240, 243, 199, 1)',
                    fontFamily: 'Poppins',
                    fontSize: '10px',
                    fontWeight: 500,
                    lineHeight: '16.03px',
                    textAlign: 'left',
                    color: 'rgba(187, 200, 8, 1)',
                    padding: '5px',
                    marginRight: '5px',
                }}
            >
                {coverageLabel}
            </span>
        </TableCell>
    );
}
export default function ListClaimToBeLoadedToPlatform(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
 const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("");
    const [selected, setSelected] = useState([]);
    const [inputType, setInputType] = useState('text'); // (for date field)
    const { taskList, loading } = useSelector((state) => state.taskReducer);
    const [dateRange, setDateRange] = useState({ fromDate: null, toDate: null }); 
    const [dateRange2, setDateRange2] = useState({ fromDate: null, toDate: null });   
    const [filteredTasks, setFilteredTasks] = useState([]);
 
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [currentTaskId, setCurrentTaskId] = useState(null);
    const navigate = useNavigate();
    const [filterTaskId, setFilterTaskId] = useState(true);
    const [definitionTaskId, setDefinitionTaskId] = useState('STEP_INSERT_CLAIM_ERECOURS');
 
    const username = localStorage.getItem('username');
    const user = useSelector(state => state.user.user);
     const userGroups = user?.groups;
    const groups = user?.userGroups[0]?.label;
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [selectedClaim, setSelectedClaim] = useState(null);
    const [searchValue ,setSearchValue] = useState(null);

    const truncateLabel = (label) =>
        label.length > 14 ? `${label.substring(0, 12)}..` : label;
 

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
    };

    
      function handleRequestSort(event, property) {
        const isDesc = orderBy === property && order === "desc";
        setOrder(isDesc ? "asc" : "desc");
        setOrderBy(property);
      }

 

    function getDateFromString(dateString) {
        if (!dateString) return "";
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        //     return `${day}/${month}/${year}`;
        return `${year}-${month}-${day}`;
    }

    function convertToDayMonthYear(dateString) {
        if (!dateString) return "";
        const [year, month, day] = dateString.split("-");
        return `${day}/${month}/${year}`;
    }

    function renderField(field) {
        return field ? field : <span className={classes.naText}>N/A</span>;
    }

    function handleExport() {
        if (!Array.isArray(filteredTasks)) {
            console.error("filteredTasks is not an array");
            return;
        }
        const dataExportToExcel = filteredTasks.map(data => {
            return {
                
                "Num_Sinistre":  data?.businessKey ||null,
                "Type Dossier":  data?.variables?.managementType?.value||null,
                "Garanties Touchés":  data?.variables?.affectedWaranties?.value||null,
                "Date Insertion Facture": convertToDayMonthYear(getDateFromString((data?.variables?.invoiceReceptionDate?.value)))||null ,
                "Date Insertion Rapport":   convertToDayMonthYear(getDateFromString((data?.variables?.finaleReportReceptionDate?.value)))||null
            };
        });
        exportToExcel(dataExportToExcel, 'Sinistre éligible au réglement.xlsx');
      }

    // number of selected rows
    const numSelected = selected.length;

    const handleDateChange = (e, type) => {
        const dateValue = e.target.value;
        if (type === 'from') {
            setDateRange({ ...dateRange, fromDate: dateValue });
        } else {
            setDateRange({ ...dateRange, toDate: dateValue });
        }
    };

    const handleDateChange2 = (e, type) => {
        const dateValue = e.target.value;
        if (type === 'from') {
            setDateRange2({ ...dateRange2, fromDate: dateValue });
        } else {
            setDateRange2({ ...dateRange2, toDate: dateValue });
        }
    };
    
    const resetDateRanges = () => {
        setDateRange(prevState => ({ ...prevState, fromDate: null, toDate: null }));
        setDateRange2(prevState => ({ ...prevState, fromDate: null, toDate: null }));  
    };
  
    
      
      const filterByDateRange = (tasks, dateField, dateRange) => {
        const { fromDate, toDate } = dateRange;
        if(fromDate === null && toDate === null){
            return tasks
        }
        // Convert fromDate and toDate to Date objects once
        const fromDateConverted = fromDate ? new Date(fromDate) : null;
        const toDateConverted = toDate ? new Date(toDate) : null;
    
        return tasks?.filter((task) => {
            const taskDateString = task.variables?.[dateField]?.value;
    
            // Skip tasks with invalid or missing date
            if (!taskDateString) return false;
    
            const taskDate = new Date(taskDateString);
    
            // Compare dates
            const isAfterFromDate = fromDateConverted ? taskDate >= fromDateConverted : true;
            const isBeforeToDate = toDateConverted ? taskDate <= toDateConverted : true;
    
            return isAfterFromDate && isBeforeToDate;
        });
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchValue(value);
 
    };

    function applyFilters() {
        if (taskList) {
            console.log("taskList",taskList)
            setFilterTaskId(definitionTaskId === 'STEP_INSERT_CLAIM_ERECOURS');
            // Filter tasks by definitionTaskId
            let filtered = taskList?.filter(task => {
                return task.taskDefinitionId === definitionTaskId;
            });

 
            if (searchValue && searchValue.trim().length > 0) {
                filtered = filtered?.filter(task => {
                    const businessKey = task.businessKey?.toLowerCase() || '';
                    return businessKey.includes(searchValue.toLowerCase());
                });
            }

            

            
            filtered = filterByDateRange(filtered, 'invoiceReceptionDate', dateRange);
            
            filtered = filterByDateRange(filtered, 'finaleReportReceptionDate', dateRange2);
            // Set the filtered tasks
            setFilteredTasks(filtered);
            // Set unique task names and responsibles for filtering 
        }
    }

    
    const handleDropdownClick = (taskId) => {
        setCurrentTaskId(taskId);
        setDropdownVisible(!dropdownVisible);
    };

    const handleViewClick = (task) => {
        setCurrentTaskId(task.taskId);
        let route = `/make_Ineligible/${task.taskId}`;
        props.setTaskId(task.taskId);
        navigate(route);
      };
 

   
    
    const tasksInfo = taskList?.filter(task => task.assignee === username || task.assignee === null);

 
 


 
     
    const fetchData = async () => {
                try {
                    if (!user) {
                        await dispatch(fetchUser());
                    }

                    if (user && user.userGroups) {
                        const userGroupsLabel = user.userGroups.map(group => group.label);
                        console.log('userGroupsLabel' , userGroupsLabel)
                        const response = await dispatch(getTasksForUser(username, userGroupsLabel)); 

                        
                    }
                } catch (error) {
                    console.error("Error fetching tasks: ", error);
                }
                
            };
 

    // filter tasks based on the current user and filter criteria
    useEffect(() => { 
        applyFilters();
        }, [taskList ,definitionTaskId, username   ,dateRange , dateRange2,searchValue ]);
 
    useEffect(() => {
            fetchData(); 
        }, [dispatch, user]);


        return (
            <div className={classes.root}> 
              
                <Paper className={classes.paper}>
                    <div className={classes.tableWrapper}>
                        <div
                            style={{display: 'flex', alignItems: 'center', marginBottom: '20px', whiteSpace: "nowrap"}}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%'
                            }}>
                                <div className={classes.titre}
                                     style={{marginRight:  '50px'  }}>
                                    Sinistre à charger sur plateforme
                                </div>
                                {filterTaskId &&
                                    <>
                                        <div style={{
                                            display: "flex",
                                            justifyContent: "space-around",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            marginLeft:  '0'  
                                        }}>
                <span className={classes.titreLabel} style={{
                    marginRight:  '20px' 
                }}>
                    N° Sinistre
                </span>
                                            <input
                                                type="text"
                                                style={{
                                                    border: '0.61px solid rgba(226, 217, 239, 1)',
                                                    background: 'rgba(255, 255, 255, 1)',
                                                    width: '250px',
                                                    height: '29.69px',
                                                    marginLeft: "0px",
                                                    borderRadius: 5,
                                                    marginRight:  '15px' 
                                                }}
                                                onChange={handleSearchChange}
                                                value={searchValue}
                                                list="claimNumbers"
                                            />

                                        </div>
                                        <div className={classes.titreLabel}
                                             style={{display: 'flex', alignItems: 'center'}}>
                                            Date dépot facture
                                            <div className={classes.dateRangeContainer}
                                                 style={{display: 'flex', alignItems: 'center', marginLeft: '15px'}}>
                                                <span style={{marginRight: '5px'}}>De</span>
                                                <input
                                                    type="date"
                                                    className={classes.dateContainer}
                                                    placeholder=''
                                                    value={dateRange.fromDate || ""}
                                                    onFocus={() => setInputType('date')}
                                                    onBlur={() => setInputType('text')}
                                                    style={{
                                                        width: '120px',
                                                        fontSize: '10px',
                                                        fontWeight: 500,
                                                        height: '20px'
                                                    }}
                                                    onChange={(e) => handleDateChange(e, 'from')}/>
                                                <span style={{marginRight: '1px'}}>Au</span>
                                                <input
                                                    type="date"
                                                    className={classes.dateContainer}
                                                    placeholder=''
                                                    value={dateRange.toDate || ""}
                                                    onFocus={() => setInputType('date')}
                                                    style={{
                                                        width: '120px',
                                                        fontSize: '10px',
                                                        fontWeight: 500,
                                                        height: '20px'
                                                    }}
                                                    onChange={(e) => handleDateChange(e, 'to')}/>
                                            </div>
                                        </div>
                                        <div className={classes.titreLabel}
                                             style={{display: 'flex', alignItems: 'center'}}>
                                            Date dépot Rapport
                                            <div className={classes.dateRangeContainer}
                                                 style={{display: 'flex', alignItems: 'center', marginLeft: '15px'}}>
                                                <span style={{marginRight: '5px'}}>De</span>
                                                <input
                                                    type="date"
                                                    className={classes.dateContainer}
                                                    placeholder=''
                                                    value={dateRange2.fromDate || ""}
                                                    onFocus={() => setInputType('date')}
                                                    onBlur={() => setInputType('text')}
                                                    style={{
                                                        width: '120px',
                                                        fontSize: '10px',
                                                        fontWeight: 500,
                                                        height: '20px'
                                                    }}
                                                    onChange={(e) => handleDateChange2(e, 'from')}/>
                                                <span style={{marginRight: '1px'}}>Au</span>
                                                <input
                                                    type="date"
                                                    className={classes.dateContainer}
                                                    placeholder=''
                                                    value={dateRange2.toDate || ""}
                                                    onFocus={() => setInputType('date')}
                                                    style={{
                                                        width: '120px',
                                                        fontSize: '10px',
                                                        fontWeight: 500,
                                                        height: '20px'
                                                    }}
                                                    onChange={(e) => handleDateChange2(e, 'to')}/>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                            <div className={classes.titre} style={{marginRight: '15px'}}></div>
                            {/* <button
                                style={{
                                    border: "0.96px solid rgba(187, 200, 8, 1)",
                                    color: "rgba(187, 200, 8, 1)",
                                    width: "64px",
                                    height: "27px",
                                    fontFamily: "Poppins",
                                    fontSize: "12.76px",
                                    fontWeight: 400,
                                    lineHeight: "19.14px",
                                    background: "rgba(255, 255, 255, 1)",
                                }}
                                onClick={handleExport}
                            >
                                Export
                            </button> */}


                        </div>
                         
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size="small"
                        >
                            <EnhancedTableHead
                                 order={order}
                                 orderBy={orderBy}
                                 onRequestSort={handleRequestSort}
                            />
                            {loading ?(
                                <TableBody>
                                    {[...Array(10)].map((row, index) => {
                                        return (
                                            <tr
                                                hover
                                                style={{height: "48px"}}
                                            >
                                                <TableCell
                                                    align="left"
                                                    className={classes.tableCellSmall}
                                                >
                                                    <Skeleton animation="wave"/>
                                                </TableCell>
                                                <TableCell
                                                    align="left"
                                                    className={classes.tableCellSmall}
                                                >
                                                    <Skeleton animation="wave"/>
                                                </TableCell>
                                                <TableCell
                                                    align="left"
                                                    className={classes.tableCellSmall}
                                                >
                                                    <Skeleton animation="wave"/>
                                                </TableCell>
                                                <TableCell
                                                    align="left"
                                                    className={classes.tableCellSmall}
                                                >
                                                    <Skeleton animation="wave"/>
                                                </TableCell>
                                                <TableCell
                                                    align="left"
                                                    className={classes.tableCellSmall}
                                                >
                                                    <Skeleton animation="wave"/>
                                                </TableCell>
                                                <TableCell
                                                    align="right"
                                                    className={classes.tableCellSmall}
                                                >
                                                    <button className={classes.viewBtn}>
                                                        <BsThreeDots/>
                                                    </button>
                                                     
                                                </TableCell>
                                            </tr>
                                        );
                                    })}
                                </TableBody>
                               ) : (
                                <>
                                  {" "}
                                {filteredTasks != null && filteredTasks?.length > 0 ? (
                                <TableBody>
                                    {stableSort(filteredTasks, getSorting(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((task, index) => {
                                            const isItemSelected = selected.indexOf(task.taskId) !== -1;
                                            const labelId = `enhanced-table-checkbox-${index}`;
                                            
    
                                              return (
                                                <tr
                                                    hover
                                                    key={task.taskId || index}
                                                    style={{height: "70px", backgroundColor: 'rgb(255, 255, 255)' , borderBottom: "1px solid  rgba(0, 0, 0, 0.08)",}}
                                                    selected={isItemSelected}
                                                >
                                                   
                                                    <TableCell align="left" className={classes.tableCellSmall}
                                                               style={{ borderBottom: 'none' }}
                                                    >
                                                        <div className={classes.sinistres}>
                                                            {renderField(task.businessKey)}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.tableCellSmall}
                                                               style={{ borderBottom: 'none' }}
                                                    >
                                                        <div className={classes.tableContent}>
                                                            {renderField(task.variables?.managementType?.value)}
                                                        </div>
                                                    </TableCell>
                                                    <CoverageCell coverageCode={task.variables?.affectedWaranties?.value} />
                                                    
                                                    <TableCell align="left" className={classes.tableCellSmall} style={{ borderBottom: 'none' }}>
                                                    <div className={classes.tableContent}>
                                                            {renderField(convertToDayMonthYear(getDateFromString((task.variables?.invoiceReceptionDate?.value))))}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.tableCellSmall} style={{ borderBottom: 'none' }}>
                                                        <div className={classes.tableContent}>
                                                            {renderField(convertToDayMonthYear(getDateFromString((task.variables?.finaleReportReceptionDate?.value))))}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="right" className={classes.tableCellSmall}
                                                               style={{ borderBottom: 'none' }}
                                                    >
                                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                                            <button className={classes.viewBtn}>
                                                            <AiOutlineEye  
                                                              onClick={() => {
                                                                setSelectedClaim(task);
                                                                setPreviewModalOpen(true);
                                                                setDropdownVisible(false);
                                                            }}/>
                                                            </button>
{/* 
                                                                {dropdownVisible && currentTaskId === task.taskId && (

                                                                    <div className={classes.dropdownMenu}>
                                                                        <div
                                                                            className={classes.dropdownItem}
                                                                          
                                                                        >
                                                                        
                                                                        </div>
                                                                       
                                                                    </div>

                                                                )} */}
                                                            {/* </button> */}

                                                        </div>
                                                    </TableCell>
                                                </tr>
                                              );
                                            })}
                                </TableBody>
                                ):(
                                    <TableBody>
                                      <TableCell
                                          align="left"
                                          style={{fontFamily : 'Poppins', fontWeight : 400 ,fontSize :15, lineHeight:'22.5px' ,color :'rgba(70, 78, 95, 1)' , padding :'20px' }}
                                          colspan="6"
                                      >
                                        {" "}
                                        Aucune action disponible
                                      </TableCell>
                                    </TableBody>
                                )}{" "}
                                </>
                           ) }
                        </Table>
                   
                    <TablePagination
                        rowsPerPageOptions={[10, 20, 30]}
                        component="div"
                        count={filteredTasks?.length || 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        backIconButtonProps={{
                            "aria-label": "Previous Page",
                        }}
                        nextIconButtonProps={{"aria-label": "Next Page",}}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        style={{
                            fontFamily: "Poppins",
                            fontSize: "12px",
                            fontWeight: 400,
                            lineHeight: "18px",
                            color: "rgba(32, 18, 70, 1)",
                          }}
                          labelRowsPerPage="Lignes par page"
                    />
                 </div>
                </Paper>
  
                <PreviewButtonPopup
                    open={previewModalOpen}
                    onClose={() => setPreviewModalOpen(false)}
                    infoSinistre={selectedClaim?.businessKey}
                />
            </div>
        )
    }    